export default {
  default: {
    createButton: 'Create',
    tabBarTitle: 'Quote Templates',
    title: 'Quote Templates',
    filtersTitle: 'Filters',
    titleLabel: 'Filter by Title',
  },
}
